import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Grid, ButtonGroup } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    container: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: 10,
    },
    navigation: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
    },
    navigationButtons: {
        marginRight: 20,
    },
    label: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        fontSize: "large",
        color: "#565656",
    },
    views: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
    },
}));

function Toolbar(props) {
    const { date, label, onView, onNavigate, view } = props;
    const classes = useStyles();

    return (
        <Grid container className={classes.container}>
            <Grid item xs={12} md={4} className={classes.navigation}>
                <ButtonGroup variant="outlined" color="primary" aria-label="outlined button group" className={classes.navigationButtons}>
                    <Button onClick={() => onNavigate("TODAY", date)}>Today</Button>
                    <Button onClick={() => onNavigate("PREV", date)}>Back</Button>
                    <Button onClick={() => onNavigate("NEXT", date)}>Next</Button>
                </ButtonGroup>
            </Grid>
            <Grid item xs={12} md={4} className={classes.label}>
                {label}
            </Grid>
            <Grid item xs={12} md={4} className={classes.views}>
                <ButtonGroup variant="outlined" color="primary" aria-label="outlined button group">
                    <Button variant={view === "day" ? "contained" : undefined} onClick={() => onView("day")}>
                        Day
                    </Button>
                    <Button variant={view === "week" ? "contained" : undefined} onClick={() => onView("week")}>
                        Week
                    </Button>
                    <Button variant={view === "month" ? "contained" : undefined} onClick={() => onView("month")}>
                        Month
                    </Button>
                    <Button variant={view === "agenda" ? "contained" : undefined} onClick={() => onView("agenda")}>
                        Schedule
                    </Button>
                </ButtonGroup>
            </Grid>
        </Grid>
    );
}

export default Toolbar;
